import React from "react";
import { Flex, Icon, Toast } from "antd-mobile";
import "./InductionManagement.scss";
import GoBack from "../../components/GoBack";
import { getItem } from "../../util/util";
import http from "../../util/api.js";
// 提交入职信息resid
const submitInfoResId = 617651844877;
/**
 * 入职管理
 */
class InductionManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      personinfo: {},
      IDlink: ""
    };
  }

  componentDidMount() {
    const userInfo = JSON.parse(getItem("userInfo"));
    let recid = JSON.parse(getItem("personal_info_recid"));
    // const REC_ID = userInfo.UserInfo.REC_ID;
    // let UserCode = userInfo.UserCode + '';

    // const id = this.props.match.params.id;
    this.getPersoninfo(recid);
  }

  // 获取个人信息
  getPersoninfo = async id => {
    try {
      let res = await http().getTable({
        resid: submitInfoResId
        // cmswhere: `intervieweeId = ${id}`
      });
      let { data } = res;

      if (data.data.length) {
        this.setState({ personinfo: data.data[0] });
        console.log("personinfo", this.state.personinfo);
        // Toast.hide();
      } else {
      }
    } catch (error) {
      console.log(error.message);
      Toast.fail(error.message);
    }
  };

  render() {
    return (
      <div className="body">
        <GoBack
          goBack={() => {
            // this.props.history.goBack();
            this.props.history.push("/personal_center");
          }}
        />
        <Flex
          className="body_mid"
          onClick={() => {
            // Toast.loading('Loading...', 1,)
            this.props.history.push("/sunmitEnterMsg");
          }}
        >
          <Flex.Item className="body_personalInfo">提交入职信息</Flex.Item>
          <Flex
            style={{
              width: "30%",
              marginRight: "5.3%",
              color: "#CCCCCC",
              display: "flex",
              justifyContent: "flex-end"
            }}
          >
            <span style={{ fontSize: "1rem" }}>
              {!this.state.personinfo.IDlink ||
              !this.state.personinfo.bankLink ||
              !this.state.personinfo.photoLInk
                ? "尚未提交"
                : "预览信息"}
            </span>
          </Flex>
          <Flex style={{ width: 30, color: "#CCCCCC" }}>
            <Icon type="right" />
          </Flex>
        </Flex>
        <Flex className="body_mid">
          <Flex.Item
            className="body_personalEnter"
            onClick={() => {
              this.props.history.push("/invite_induction");
            }}
          >
            邀请入职
          </Flex.Item>
          <Flex style={{ width: 30, color: "#CCCCCC" }}>
            <Icon type="right" />
          </Flex>
        </Flex>
      </div>
    );
  }
}
export default InductionManagement;
